import { useState } from 'react';
import Draggable from '../../../Draggable';
import useStore from '../../../Hooks/useStore';
import {
  FormBannerPreview,
  Header,
  Label,
  SliderContainerWrapper,
} from './Style';
import BannerContentPreview from './Content';
import Banner from '..';

interface BannerPreview {
  width: number;
  height: number;
  headerHeight?: number;
  margin?: number;
  elements: any;
  backGroundImageUrl: string | null;
}

function BannerPreview({
  width = 0,
  height = 0,
  headerHeight = 0,
  margin = 0,
  elements,
  backGroundImageUrl,
}: BannerPreview) {
  const [zoom, setZoom] = useState(0.5);
  return (
    <FormBannerPreview
      style={{
        margin: `0 ${margin}px 0 0`,
      }}
    >
      <Header
        style={{
          minHeight: headerHeight,
        }}
      >
        <div
          style={{
            width: '100%',
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            marginBottom: 10,

            background: '#D9D9D9',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              width: '50%',
              display: 'flex',
              alignItems: 'center',
              marginLeft: 10,
              color: '#364856',
              fontSize: 17,
              fontWeight: '500',
            }}
          >
            Preview
          </div>

          <div
            style={{
              display: 'flex',
              width: '50%',
              alignItems: 'center',
              justifyContent: 'end',
            }}
          >
            <div
              style={{
                color: '#364856',
                fontSize: 17,
                fontWeight: 'bold',
                marginRight: 10,
              }}
            >
              Zoom
            </div>
            <SliderContainerWrapper
              style={{
                margin: `0 ${margin}px 0 0`,
              }}
            >
              <Draggable.Slider value={zoom} setValue={setZoom} />
            </SliderContainerWrapper>
          </div>
        </div>
      </Header>
      <div
        style={{
          transformOrigin: '50% 0%',

          transform: `matrix(${(width - 2 * margin) / width}, 0, 0, ${
            (height - margin) / height
          }, 0, 0)`,
        }}
      >
        <Banner.Preview.Content
          elements={elements}
          width={width}
          height={height}
          zoom={zoom}
          backgroundImageUrl={backGroundImageUrl ?? ''}
        />
      </div>
    </FormBannerPreview>
  );
}

export default Object.assign(BannerPreview, {
  Content: BannerContentPreview,
});
